import React from 'react';
import { useAppSelector } from '../../../../store';
import { Button, Skeleton, Stack } from '@mui/material';
import { ConstImages } from '../../../../shared/constants';
import './style.scss';

const ContactTypes: React.FC = () => {
    const { personData, personLoading } = useAppSelector((state) => state.person);

    return (
        <Stack
            spacing={2}
            direction={{ xs: 'column', md: 'row' }}
            id='contacts-types'
        >
            {personLoading ? (
                <Button className='email-container' sx={{ textTransform: 'none' }}>
                    <Skeleton variant="rectangular" width={40} height={40} />
                    <Skeleton variant="text" width={100} />
                </Button>
            ) : (
                personData.map((person: any) => (
                    <Button className='email-container' sx={{ textTransform: 'none' }} key={person.name}>
                        <img className='w-12' src={ConstImages.email} alt='email' />
                        <a className='text-lg text-gray-600' href={`mailto:${person.email}`}>@Mail</a>
                    </Button>
                ))
            )}
        </Stack>
    );
};

export default ContactTypes;
